import React from "react";
//#region redux
import { useDispatch } from "react-redux";
import { displayDialog } from "store/actions/utilActions";
//#endregion
//#region types
import { TranslationKeys } from "translations";
import { ACTION_SEPARATOR } from "models/propTypes/menuPropTypes";
import { AutomationRuleFormTypes } from "models/formTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { DashboardButtonGroup, FilterButton, PageLayouts, ReloadEvent, StyledButton } from "components/common";
import AutomationRuleList from "./list";
import { useCreateAutomationRuleDialog, useAutomaticRuleFilterDefinition } from "components/automationRule";
import { useAutomationRuleService } from "serviceHooks";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const AutomationRuleReport: React.FC = () => {
  const dispatch = useDispatch();
  const automationRuleService = useAutomationRuleService();
  const { filterFormFields, filterQueryStateHandler, apiToReportFilterFormatter } = useAutomaticRuleFilterDefinition();

  const getCreateDialog = useCreateAutomationRuleDialog();
  const onCreateRuleClick = (onSubmitSuccess?: () => void) => {
    dispatch(displayDialog(getCreateDialog(undefined, undefined, onSubmitSuccess)));
  };

  return (
    <ReloadEvent
      render={(reloadKey, reload) => (
        <PageLayouts.DashboardLayout<AutomationRuleFormTypes.Filter>
          entityKey={0}
          title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Automation)}
          topRightButtons={
            <DashboardButtonGroup
              buttons={[
                <StyledButton size="sm" onClick={onCreateRuleClick.bind(null, reload)}>
                  {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.AutomationRule.CreateRule)}
                </StyledButton>,
                ACTION_SEPARATOR,
                <FilterButton />,
              ]}
            />
          }
          filterFields={filterFormFields}
          initialFilter={{ active: true }}
          filterQueryStateHandler={filterQueryStateHandler}
          reportToAPIFilterFormatter={automationRuleService.reportToAPIFilter}
          apiToReportFilterFormatter={apiToReportFilterFormatter}
        >
          <Grid container item>
            <AutomationRuleList reloadKey={reloadKey} reloadList={reload} />
          </Grid>
        </PageLayouts.DashboardLayout>
      )}
    />
  );
};

export default AutomationRuleReport;
